import { useQuery } from "react-query";
import {
    GetListPenyewaResponse,
    ParamsGetListPenyewa,
} from "../../constants/types";
import axios from "../axios";

const queryString = require("query-string");

const handleRequest = async (params: ParamsGetListPenyewa) => {
    const apiGetListPenyewa = queryString.stringifyUrl({
        url: "/api/mpenyewas",
        query: {
            size: params.size,
            page: params.page,
            search: params.search,
            status: params.status,
            tanggalAwal: params.tanggalAwal,
            tanggalAkhir: params.tanggalAkhir,
        },
    });
    const { data } = await axios.get<GetListPenyewaResponse>(
        apiGetListPenyewa,
    );
    return data.data;
};

export default function useListPenyewa(params: ParamsGetListPenyewa, options?: { enabled?: boolean }) {
    return useQuery<GetListPenyewaResponse["data"]>(
        ["list-penyewa", params],
        () => handleRequest(params),
        {
            enabled: options?.enabled ?? true,
        }
    );
}